var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowheadLinearGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10.3334C9.68845 10.334 9.38653 10.2255 9.14665 10.0267L1.14665 3.36002C0.874359 3.1337 0.703126 2.80849 0.67062 2.45592C0.638114 2.10335 0.746996 1.75231 0.973314 1.48002C1.19963 1.20773 1.52485 1.0365 1.87742 1.00399C2.22998 0.971488 2.58103 1.08037 2.85331 1.30669L9.99998 7.28002L17.1466 1.52002C17.283 1.40927 17.44 1.32656 17.6084 1.27665C17.7769 1.22674 17.9535 1.21062 18.1282 1.2292C18.3029 1.24779 18.4722 1.30072 18.6264 1.38495C18.7806 1.46918 18.9166 1.58305 19.0266 1.72002C19.1488 1.85712 19.2412 2.01795 19.2983 2.19245C19.3553 2.36695 19.3758 2.55135 19.3582 2.7341C19.3407 2.91685 19.2856 3.09401 19.1965 3.25449C19.1073 3.41497 18.9859 3.5553 18.84 3.66669L10.84 10.1067C10.5932 10.274 10.2974 10.3538 9.99998 10.3334Z",
    fill: "url(#paint0_linear_1183_3527)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1183_3527",
    x1: 19.869,
    y1: 0.0442365,
    x2: 4.31543,
    y2: 14.3151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00902,
    stopColor: "#F6CD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391861,
    stopColor: "#DCAE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707524,
    stopColor: "#C8963B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#B9852D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#B17A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3046,
    stopColor: "#CE9E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#E8BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4902,
    stopColor: "#F2CB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    stopColor: "#ECC466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    stopColor: "#DDB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7132,
    stopColor: "#C3923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#B27C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#BF8B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9189,
    stopColor: "#D3A446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    stopColor: "#F0C660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowheadLinearGradient);
export default __webpack_public_path__ + "static/media/arrowhead-linear-gradient.396fe63b479b653369f9aed194adc3f1.svg";
export { ForwardRef as ReactComponent };